import MicroModal from 'micromodal';

/**
 * Iframe DOM element
 * @param {string} youtubeLink vimeo video url
 * @return {HTMLElement}
 */
const iframeModalDOM = (youtubeLink) => {
  return `
    <div
      class="youtube-modal"
      role="dialog"
      aria-hidden=true
      id="youtube-modal"
      data-micromodal-close
    >
        <iframe
          src="${youtubeLink}"
          width="640"
          height="360"
          frameborder="0"
          allowfullscreen
          allow="autoplay; fullscreen; picture-in-picture;"
        ></iframe>
    </div>
  `;
};

const removeModal = (modalId) => {
  document.getElementById(modalId).remove();
};

const youtube = {
  init() {
    const youtubePlayers = document.querySelectorAll('[data-module="youtube-player"');

    // Checks for availiabilty of Vimeo Players on the current page
    youtubePlayers.length && youtubePlayers.forEach((youtubePlayer) => {
      youtubePlayer.addEventListener('click', (event) => {
        event.preventDefault();

        const youtubeButton = event.target.closest('[data-element="youtube-button"]');

        if (!youtubeButton) return;

        // Falls back to the `data-src` attribute if we arent using an a tag
        const youtubeUrl = youtubeButton.href || youtubeButton.dataset.src;

        const iframeModalDom = iframeModalDOM(`${youtubeUrl}`);
        document.body.insertAdjacentHTML('beforeend', iframeModalDom);

        // Construct the iframe and open it up
        MicroModal.show(
          'youtube-modal',
          {
            onClose: (modal) => removeModal(modal.id),
            openTrigger: '[data-element="youtube-button"]',
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
          });
      });
    });
  },
};

export default youtube;
